export default function Leadership() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-[#C5A55A] mb-16 text-center">
          Leadership
        </h2>

        {/* Matt Crance Profile */}
        <div className="grid md:grid-cols-2 gap-12 items-start mb-20">
          {/* Left: Photo */}
          <div className="w-full">
            <div className="w-full h-[600px] bg-gray-100 rounded-lg overflow-hidden">
              <img
                src="https://static.readdy.ai/image/cba2a97821e3b69b611dea227959f307/ab071a148d72b1c3c6edf8518692cc07.webp"
                alt="Matt Crance, President of Deer Point Contracting"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right: Bio */}
          <div className="flex flex-col justify-start">
            <h3 className="text-3xl font-bold text-[#2B2B2B] mb-2">
              Matt Crance
            </h3>
            <p className="text-xl text-[#C5A55A] mb-6 font-semibold">
              President
            </p>
            
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Matt Crance is President of Deer Point Contracting. He helps clients realize both tangible and intangible benefits by leveraging his 18 years of multifamily and commercial experience. As President, Matt is accountable for engaging all clients on the front-end of all deals and ensures each project is successfully executed.
              </p>
              
              <p>
                Since 2003, Matt has supplied, built, and renovated market-rate and affordable housing projects throughout the United States, both urban and rural. Having spent nearly two decades in the field, office, and everywhere in between, Matt brings knowledge and an experienced perspective to every project team. He has successfully built/renovated over 3,600 units and completed $225 million+ in contract work throughout the United States.
              </p>
              
              <p>
                Prior to starting Deer Point Contracting with Christina, Matt spent 18 years working with some of the region's most recognizable contractors, honing his skills in exterior and interior construction of commercial and multifamily asset classes. Most recently, he was a Vice President at a regional contractor specializing in servicing the capex and renovation needs of institutional investors pursuing value-add properties throughout the Mid-Atlantic.
              </p>
              
              <p>
                Matt earned his undergraduate degree from Elon University in 2003 and his Masters of Business Administration (MBA) with a focus in Real Estate from Johns Hopkins's Carey Business School in 2017. When not with his family, Matt is an avid outdoorsman and enjoys hunting, fishing, and golfing.
              </p>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-200 mb-16"></div>

        {/* Growing Team Section */}
        <div className="text-center max-w-3xl mx-auto">
          <h3 className="text-2xl font-bold text-[#2B2B2B] mb-4">
            Our Growing Team
          </h3>
          <p className="text-lg text-gray-700 leading-relaxed">
            Deer Point Contracting is building a team of experienced construction professionals. As we grow, we will introduce more of the people behind our projects.
          </p>
        </div>
      </div>
    </section>
  );
}